export default __webpack_public_path__ + "static/media/token-utility.c52a5501.png";